<ng-container *ngIf="group">
  <tr *ngIf="group.components" 
  class="group-toggle" 
  [attr.depth]="depth">        
      <td (click)="toggleClass($event,'expanded')">
          <span class="d-flex align-items-center">
              <i class="far fa-angle-down"></i> {{group.title ? group.title : (group.label ? group.label : (group.name ? group.name : group.key))}}
          </span>
      </td>
      <td *ngFor="let determinant of determinants"
      (click)="onGroupClick()">
        <i class="fas fa-check" *ngIf="haveDeterminant(determinant.determinantId)"></i>
      </td>
  </tr>
  <tbody *ngIf="group.components">
      <fields-group-determinant
          *ngFor="let g of group.components;"
          [group]="g"
          [determinants]="determinants"
          [depth]="depth + 1"
          (onRelationChange)="onGroupClick($event)">
      </fields-group-determinant>
  </tbody>
  <tr *ngIf="!group.components"
  [attr.depth]="depth">
      <td>{{group.title ? group.title : (group.label ? group.label : (group.name ? group.name : group.key))}}</td>
      <td *ngFor="let determinant of determinants;" 
      (click)="onGroupClick()"
      class="field-reg-rel">
          <span class="cursor-pointer">
              <i class="fas fa-check" *ngIf="haveDeterminant(determinant.determinantId)"></i>
          </span>
      </td>
  </tr>
</ng-container>